import { DependencyItemObject } from "./dependency-item-object.model";
import { TreeItemObject } from "./tree-item-object.model";

export class CatalogTreeCardObject extends TreeItemObject {
    private _id: string;

    constructor(id: string, name: string, type: string, version: string,
        dependencies: Array<DependencyItemObject>, children: Array<TreeItemObject>) {
        super(name, type, version, dependencies, children);
        this._id = id;
    }


    public static create(): CatalogTreeCardObject {
        return new CatalogTreeCardObject('', '', '', '', new Array(), new Array());
    }


    public get id(): string {
        return this._id;
    }
    

    public getLevel(): number {
        if (this.type === 'PRODUCT') {
            return 1;
        } else if (this.type === 'CFS') {
            return 2;
        } else {
            return 3;
        }
    }
}